import { render } from "./AcEmpty.vue?vue&type=template&id=3b2415ae&scoped=true&ts=true"
import script from "./AcEmpty.vue?vue&type=script&lang=ts"
export * from "./AcEmpty.vue?vue&type=script&lang=ts"

import "./AcEmpty.vue?vue&type=style&index=0&id=3b2415ae&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2415ae"]])

export default __exports__